import React, { FC, Fragment } from 'react';
import { Headline4, TextDefault } from '../../../Text';
import { Flexbox, FlexboxVertical, ListULContainer } from '../../../Layout';
import { PanelWithGradient } from '../../../PanelWithGradient';
import styled from 'styled-components';
import { Product } from '../../../../../interfaces/Product';

const MetaInfoSectionWrapper = styled(FlexboxVertical)`
  margin-bottom: 4.5rem;

  ${Flexbox} {
    align-items: flex-start;
  }

  ${PanelWithGradient} {
    max-width: 24rem;
    margin-right: 2.5rem;
  }
`;

const MetaInfoTable = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem 3rem;
  flex: 1;
  padding-right: 6rem;
`;

interface Props {
  product?: Product;
}
export const MetaInfoPanel: FC<Props> = ({ product, ...props }) => {
  const features = product?.metaProduct?.productFeatures?.features || {};
  const requirements = product?.metaProduct?.productFeatures?.requirements || [];
  return (
    <ListULContainer>
      <MetaInfoSectionWrapper>
      {
        Object.keys(features).length > 0 && product?.metaProduct?.productFeatures?.title &&
        <Headline4>Produktmerkmale</Headline4>
      }
      <Flexbox>
        {
          Object.keys(features).length > 0 &&
          <MetaInfoTable>
            {
              Object.keys(features).map((key) => (
                <>
                {
                  features[key] &&
                  <>
                    <TextDefault dangerouslySetInnerHTML={{ __html: key }} />
                    <TextDefault dangerouslySetInnerHTML={{ __html: features[key] }} />
                  </>
                }
                </>
              ))
            }
          </MetaInfoTable>
        }

        {
          requirements?.length > 0 &&
          <PanelWithGradient product={product}>
            <Headline4>Produktvoraussetzungen</Headline4>
            <TextDefault>
              {
                requirements?.map((item, index) => (
                  <Fragment key={index}>
                    {
                      index > 0 && <><br /><br /></>
                    }
                    {item}
                  </Fragment>
                ))
              }
            </TextDefault>
          </PanelWithGradient>
        }
      </Flexbox>
    </MetaInfoSectionWrapper>
    </ListULContainer>
  );
};
